export const API_URL = process.env.VUE_APP_API_URL
export const KENIU_URL = process.env.VUE_APP_API_KENIU_URL
